// extracted by mini-css-extract-plugin
export default {"loginContent":"styles_loginContent__wPkKW","icon":"styles_icon__5UVqs"};